/**
 * InquiryDetailContainer
 * --
 */
import { useState, useEffect } from 'react';
import MessageAlert from 'utils';
import { InquiryApi } from 'api';
import InquiryDetailPresenter from './InquiryDetailPresenter';
import { useUserStack } from 'store';
import moment from 'moment';

/**----------------------------------------
 * [Component] 총관리자: 문의상세 - 컨테이너
 * ----------------------------------------
 */
const InquiryDetailContainer = ({
  inquiryId,
  modalData,
  onSaved,
  setIsOpened,
  onDeleted,
  FAQ,
  FAQCategories,
  viewType = 'RECEIVED',
  permission = 'SHOP',
}) => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();

  /* ===== STATE ===== */
  const [reviewData, setReviewData] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [faqSubject, setFaqSubject] = useState('');
  // const [faqContent, setFaqContent] = useState('');
  // const [answer, setAnswer] = useState('');
  const [modalDetail, setModalDetail] = useState(null);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**--------------------
   * 리뷰목록 조회
   * --------------------
   */
  const getData = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await InquiryApi.getInquiry(inquiryId, {
        join_tables: `["user", "product", "inquiry_file"]`,
      });
      if (status !== 200) throw { message };
      setTimeout(() => {
        setReviewData(data);
        setLoading(false);
      }, 750);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };
  /**--------------------
   * 답변저장
   * --------------------
   */
  const handleSaveAnswer = async () => {
    setLoading(true);
    try {
      // 예외처리
      if (
        !modalDetail?.inquiry_name ||
        !modalDetail?.inquiry_content ||
        !userInfo.admin_id
      ) {
        MessageAlert.warning('입력데이터를 확인해주세요');
        setModalDetail(modalData);
        return;
      }

      const newData = {
        ...(inquiryId && { inquiry_id: inquiryId }),
        inquiry_answer_id: `${userInfo.admin_id}`,
        ...(FAQ === true && {
          inquiry_name: modalDetail?.inquiry_name,
          inquiry_content: modalDetail?.inquiry_content,
        }),
        inquiry_answer:
          modalDetail?.inquiry_answer === ''
            ? null
            : modalDetail?.inquiry_answer,
        updated_at: moment().unix(),
      };
      // API
      let result;
      if (!inquiryId) {
        result = await InquiryApi.createInquiry({
          ...newData,
          inquiry_type: 'FAQ',
        });
      } else {
        result = await InquiryApi.updateInquiry(newData);
      }
      const { status, message, data } = result;
      if (status !== 200) throw { message };

      setTimeout(() => {
        const dd = {
          ...data,
          inquiry_answer: newData.inquiry_answer,
        };
        MessageAlert.info('저장되었습니다.');
        setModalDetail(null);
        setLoading(false);
        setIsOpened(false);
        // setAnswer('');
        onSaved(dd);
      }, 750);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 750);
    }
  };

  /**--------------------
   * FAQ삭제
   * --------------------
   */
  const handleDeleteFAQ = async () => {
    // 예외처리
    // if (!FAQ) {
    //   MessageAlert.warning('데이터를 삭제할 수 없습니다');
    //   return;
    // }
    if (
      !window.confirm(
        '데이터를 삭제하시겠습니까?\n삭제한 데이터는 복구할 수 없습니다.'
      )
    ) {
      return;
    }
    setLoading(true);
    try {
      const { status, message } = await InquiryApi.deleteInquiry(inquiryId);
      if (status !== 200) throw { message };

      setTimeout(() => {
        MessageAlert.info('삭제되었습니다.');
        onDeleted(inquiryId);
        setIsOpened(false);
      }, 750);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    inquiryId && getData();
  }, [inquiryId]);

  //모달 데이터 초기화
  useEffect(() => {
    setModalDetail(modalData);
  }, [modalData]);

  /**
   * 데이터 바인딩 함수
   * --
   * @param {string} target
   * @param {*} value
   * @param {*} callback
   */
  const handleChange = (t, v, callback = null) => {
    let newData = { ...modalDetail };
    newData[t] = v;
    const d = {
      ...newData,
    };
    setModalDetail(d);
  };

  // useEffect(() => {
  //   setAnswer(rawData?.inquiry_answer);
  // }, [rawData.inquiry_answer]);

  /* ===== RENDER ===== */
  return (
    <>
      <InquiryDetailPresenter
        FAQ={FAQ}
        reviewData={reviewData}
        modalDetail={modalDetail}
        onChange={handleChange}
        onSaveAnswer={handleSaveAnswer}
        onDeleteFAQ={handleDeleteFAQ}
        loading={loading}
        FAQCategories={FAQCategories}
        viewType={viewType}
        permission={permission}
      />
    </>
  );
};

export default InquiryDetailContainer;
